import { apiDelete, apiGet, apiPost, apiPostForm, apiPut } from './api';

export function listEmails({ asOf } = {}) {
  const query = asOf ? `?asOf=${encodeURIComponent(asOf)}` : '';
  return apiGet(`/api/emails${query}`);
}

export function addEmail(payload) {
  return apiPost('/api/emails', payload);
}

export function updateEmail(id, payload) {
  return apiPut(`/api/emails/${id}`, payload);
}

export function deleteEmails(ids) {
  return apiDelete('/api/emails', { ids });
}

export function importEmails(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/emails/import', formData);
}

export function verifyImportEmails(file) {
  const formData = new FormData();
  formData.append('file', file);
  return apiPostForm('/api/emails/import/verify', formData);
}

export async function bulkAddEmails(emails) {
  const response = await apiPost('/api/emails/bulk', { emails });
  return response.data;
}
